import { StoreIdCookieInformationService, ZipCodeCookieInformationService } from '@inter-ikea-kompis/services';
import { useCallback, useEffect, useState } from 'react';
import { usePresetStoreId } from '../contexts/environment';
import { useKompis } from '../contexts/kompis';
import { useAppDispatch } from '../store';
import { setStoreId, setZipCode } from '../store/app';
/**
 * Hook for initializing zip code, store ID and list of stores.
 * Will also subscribe to zip and store changes.
 * Will match what has been entered on ikea.com.
 */
export const useCookieSubscription = () => {
    const dispatch = useAppDispatch();
    const { dexfAppSettings } = useKompis();
    const presetStoreId = usePresetStoreId();
    const [storeCookieService, setStoreCookieService] = useState();
    const [zipCookieService, setZipCookieService] = useState();
    const storeChangeListener = useCallback((storeId) => {
        if (presetStoreId) {
            return;
        }
        dispatch(setStoreId(storeId ?? ''));
    }, [dispatch, presetStoreId]);
    const zipChangeListener = useCallback((zipCode) => {
        dispatch(setZipCode(zipCode ?? ''));
    }, [dispatch]);
    useEffect(() => {
        const initServices = async () => {
            const storeCookieService = new StoreIdCookieInformationService({ settings: dexfAppSettings });
            const zipService = new ZipCodeCookieInformationService({ settings: dexfAppSettings });
            setStoreCookieService(storeCookieService);
            setZipCookieService(zipService);
        };
        initServices();
    }, [dexfAppSettings]);
    useEffect(() => {
        const fetchZipCode = async () => {
            if (zipCookieService) {
                const zip = await zipCookieService.getZipCode();
                dispatch(setZipCode(zip ?? ''));
            }
        };
        fetchZipCode();
    }, [dispatch, zipCookieService]);
    useEffect(() => {
        const fetchStoreId = async () => {
            if (storeCookieService && !presetStoreId) {
                const storeId = await storeCookieService.getStoreId();
                storeId && dispatch(setStoreId(storeId ?? ''));
            }
        };
        fetchStoreId();
    }, [dispatch, presetStoreId, storeCookieService]);
    useEffect(() => { });
    // Subscribe to store changes
    useEffect(() => {
        if (storeCookieService) {
            storeCookieService.subscribe(storeChangeListener);
        }
        return () => {
            storeCookieService?.unsubscribe(storeChangeListener);
        };
    }, [storeCookieService, storeChangeListener]);
    // Subscribe to zip code changes
    useEffect(() => {
        if (zipCookieService) {
            zipCookieService.subscribe(zipChangeListener);
        }
        return () => {
            zipCookieService?.unsubscribe(zipChangeListener);
        };
    }, [zipCookieService, zipChangeListener]);
};
//# sourceMappingURL=useCookieSubscription.js.map